import { render } from "./AdditionalResources.vue?vue&type=template&id=377fb7ea&scoped=true"
import script from "./AdditionalResources.vue?vue&type=script&lang=js"
export * from "./AdditionalResources.vue?vue&type=script&lang=js"

import "./AdditionalResources.vue?vue&type=style&index=0&id=377fb7ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377fb7ea"]])

export default __exports__